
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/recuperar",
      function () {
        return require("private-next-pages/auth/recuperar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/recuperar"])
      });
    }
  